import React from 'react';
import { connect } from 'dva';
import { Modal, Button } from 'antd';
import moment from 'moment';
import { DATE_TIME_FORMAT } from '@/constants';

import './index.less';

class AiEula extends React.Component {
  state = {
    values: {},
  };

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch({ type: 'userModel/getUsersProfile' });
    dispatch({ type: 'aiEulaModel/getEulasLatest' }).then(() => this.setValues());
  }

  setValues = (event) => {
    const {
      userModel: { profile },
    } = this.props;
    const values = {};
    const aiEulaDOMs = document.querySelectorAll('.ai-eula-body input[type="radio"');
    if (aiEulaDOMs.length > 0) {
      aiEulaDOMs.forEach((item) => {
        if (!event && profile.aiEulaUpTodate && item.value === 'true') {
          item.checked = true;
        }
        if (!item.name) return;
        if (values[item.name] !== undefined && !item.checked) return;
        values[item.name] = item.checked && item.value === 'true' ? true : false;
      });

      this.setState({ values });
    }
  };

  render() {
    const {
      aiEulaModel: { latestEula },
      userModel: { profile },
      onCancel,
      dispatch,
    } = this.props;
    const { values } = this.state;

    return (
      <Modal
        open
        className="ai-eula-modal"
        width={600}
        closable={false}
        title="Mandatory Acknowledgements"
        footer={
          <>
            <Button
              type="text"
              onClick={onCancel}
            >
              Cancel
            </Button>
            <Button
              type="primary"
              className="ant-btn-red"
              onClick={() => {
                onCancel && onCancel();
                dispatch({
                  type: 'userModel/patchUsersAiEulaVersion',
                  payload: false,
                });
                dispatch({
                  type: 'chatbotModel/setState',
                  payload: { chatbotVisible: false },
                });
              }}
            >
              Decline
            </Button>
            <Button
              type="primary"
              className="ant-btn-green"
              disabled={
                Object.keys(values).length > 0 &&
                Object.values(values).some((item) => item === false)
              }
              onClick={() => {
                onCancel && onCancel();
                dispatch({
                  type: 'userModel/patchUsersAiEulaVersion',
                  payload: true,
                });
                dispatch({
                  type: 'chatbotModel/setState',
                  payload: { chatbotVisible: true },
                });
              }}
            >
              Accept all
            </Button>
          </>
        }
      >
        <div className="ai-eula-body">
          {profile.aiEulaAcceptedDate && (
            <div className="ai-eula-label">
              Response Date: {moment(profile.aiEulaAcceptedDate).format(DATE_TIME_FORMAT)}
            </div>
          )}
          <div
            className="ai-eula-text"
            onClick={this.setValues}
            dangerouslySetInnerHTML={{ __html: latestEula.body }}
          />
          {latestEula.file && (
            <div>
              <b>Attachment: </b>
              <a
                download
                href={`/${latestEula.file.path}/${latestEula.file.filename}`}
              >
                {latestEula.file.originalName}
              </a>
            </div>
          )}
        </div>
      </Modal>
    );
  }
}

export default connect(({ aiEulaModel, userModel }) => ({
  aiEulaModel,
  userModel,
}))(AiEula);
